export const ICON_SIZE = 19;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/util/constants.js